import { sendApi } from ".";
import { T_File } from "../model/fileModel";

async function fileDelete(data1?:T_File){

    const response = await sendApi({
    method: "post",
    url: "/auth/filedelete",
    data: {
      ...data1,
    },
  });

  return response;
}  


const common = {
    fileDelete,
  };
  export default common;

